module.exports = __webpack_public_path__ + "img/firefox.1f1658dd.svg";